import { render, staticRenderFns } from "./PostCell.vue?vue&type=template&id=ccec024a&"
import script from "./PostCell.vue?vue&type=script&lang=js&"
export * from "./PostCell.vue?vue&type=script&lang=js&"
import style0 from "./PostCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports